export default {
  // 手机号： 1开头，第二位是3-9之间的数字，后面9位只能是0-9之间的数字
  mob: new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/),
  // 密码：8-18位数字和字母组合，包含符号
  pwd: new RegExp(/^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/)
}
